(function () {
    'use strict';

    angular
        .module('jotApp')
        .directive('evaluateAuthorities', evaluateAuthorities);

    function evaluateAuthorities(Principal, $q) {
        var directive = {
            restrict: 'A',
            link: linkFunc,
            evaluate: evaluate
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.evaluateAuthorities.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.remove();
                },
                defineVisibility = function (reset) {
                    if (reset) {
                        setVisible();
                    }

                    evaluate(authorities).then(function (resultString) {
                        var result = eval(resultString);
                        if (result) {
                            setVisible();
                        } else {
                            setHidden();
                        }
                    });
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }

        function evaluate(expression) {
            var deferred = $q.defer();
            var indexAnd = expression.indexOf("&&");
            var indexOr = expression.indexOf("||");
            if (indexAnd > 0 && (indexAnd < indexOr || indexOr < 0)) {
                var condition = expression.substr(0, indexAnd);
                var exp = expression.substr(indexAnd + 2);
                if (condition.indexOf("!") != -1) {
                    condition = condition.substr(1);
                    Principal.hasAuthority(condition)
                        .then(function (result) {
                            evaluate(exp).then(function (res) {
                                deferred.resolve("!" + result.toString() + "&&" + res);
                                return deferred.promise;
                            });
                        });
                } else {
                    Principal.hasAuthority(condition)
                        .then(function (result) {
                            evaluate(exp).then(function (res) {
                                deferred.resolve(result.toString() + "&&" + res);
                                return deferred.promise;
                            });
                        });
                }
            } else if (indexOr > 0 && (indexAnd > indexOr || indexAnd < 0)) {
                var condition = expression.substr(0, indexOr);
                var exp = expression.substr(indexOr + 2);
                if (condition.indexOf("!") != -1) {
                    condition = condition.substr(1);
                    Principal.hasAuthority(condition)
                        .then(function (result) {
                            evaluate(exp).then(function (res) {
                                deferred.resolve("!" + result.toString() + "||" + res);
                                return deferred.promise;
                            });
                        });
                } else {
                    Principal.hasAuthority(condition)
                        .then(function (result) {
                            evaluate(exp).then(function (res) {
                                deferred.resolve(result.toString() + "||" + res);
                                return deferred.promise;
                            });
                        });
                }
            } else {
                if (expression.indexOf("!") != -1) {
                    expression = expression.substr(1);
                    Principal.hasAuthority(expression)
                        .then(function (result) {
                            deferred.resolve("!" + result.toString());
                            return deferred.promise;
                        });
                } else {
                    Principal.hasAuthority(expression)
                        .then(function (result) {
                            deferred.resolve(result.toString());
                            return deferred.promise;
                        });
                }
            }

            return deferred.promise;
        }
    }
})();
